import { useEffect } from 'react';
import FormImage from '@/assets/Onboarding/FormImage.png';

type UnavailableQuestionnairePageProps = {
  pastConsultation?: boolean;
};

export const UnavailableQuestionnairePage = ({
  pastConsultation = false,
}: UnavailableQuestionnairePageProps) => {
  useEffect(() => {
    console.log('questionnaire unavailable');
  }, []);
  return (
    <div className="h-full flex flex-col items-center justify-center gap-3 px-4 n2xs:px-6 nsm:px-0 pb-10 nsm:pb-0">
      <img src={FormImage} alt="Formulaire" className="w-40" />
      <p className="text-center text-3.5xl font-medium">
        Ce questionnaire n&apos;est <br /> plus disponible.
      </p>
      {pastConsultation && (
        <p className="text-center">La consultation est passée.</p>
      )}
      <a
        href="https://aldebaran.care/patient/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-center font-light underline text-primaryBlue"
      >
        En savoir plus sur Aldebaran
      </a>
    </div>
  );
};
